import { render, staticRenderFns } from "./SalaMunicipioHeader.vue?vue&type=template&id=17c06e9e&"
import script from "./SalaMunicipioHeader.vue?vue&type=script&lang=js&"
export * from "./SalaMunicipioHeader.vue?vue&type=script&lang=js&"
import style0 from "./SalaMunicipioHeader.vue?vue&type=style&index=0&id=17c06e9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports